<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Dealership'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-building"></p-inputicon>
                <input
                        pInputText
                        id="dealership-name"
                        [(ngModel)]="this.dealership.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Dealership Name"
                />
            </p-iconfield>
            <label for="dealership-name">Dealership Name <span class="text-red-500">*</span></label>
        </p-ifta-label>
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-id-card"></p-inputicon>
                <input
                        pInputText
                        id="dealership-gssn"
                        [(ngModel)]="this.dealership.gssn"
                        autocomplete="off"
                        class="w-full"
                        placeholder="GSSN"
                />
            </p-iconfield>
            <label for="dealership-gssn">GSSN</label>
        </p-ifta-label>
        <p-ifta-label>
            <p-select
                    id="dealership-country"
                    [(ngModel)]="this.dealership.countryId"
                    [options]="availableCountries"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Country"
                    class="w-full"
                    appendTo="body"
            ></p-select>
            <label for="dealership-country">Country <span class="text-red-500">*</span></label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveDealership()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
